import React, { Fragment, useState } from "react";
import Typography from "@mui/material/Typography";
import { useSelector, useDispatch } from "react-redux";

import { SNETTextfield, alertTypes } from "shared/dist/components";
import { organizationActions } from "../../../../Services/Redux/actionCreators";
import validator from "shared/dist/utils/validator";
import { orgProfileValidationConstraints } from "../validationConstraints";
import StorageTypeSelecting from "../../../../Components/StorageTypeSelecting";
import classes from "../OrganizationProfile.module.css";

const BasicDetails = () => {
    const organization = useSelector((state) => state.organization);
    const { id, name, shortDescription, longDescription, website, storageProvider } = organization;
    const dispatch = useDispatch();
    const [websiteValidation, setWebsiteValidation] = useState();
    const [nameValidation, setNameValidation] = useState();

    const handleWebsiteValidation = (value) => {
        const invalidWebsiteMessage = validator.single(
            value,
            orgProfileValidationConstraints.website
        );
        if (invalidWebsiteMessage) {
            setWebsiteValidation({
                type: alertTypes.ERROR,
                message: invalidWebsiteMessage[0], // invalidWebsiteMessage is single-element array
            });
        } else {
            setWebsiteValidation();
        }
    };

    const handleOrganizationNameValidation = (value) => {
        const invalidNameMessage = validator.single(value, orgProfileValidationConstraints.name);
        if (invalidNameMessage) {
            setNameValidation({
                type: alertTypes.ERROR,
                message: invalidNameMessage[0], // invalidNameMessage is single-element array
            });
        } else {
            setNameValidation();
        }
    };

    const handleValidation = {
        website: handleWebsiteValidation,
        name: handleOrganizationNameValidation,
    };

    const handleFormInputsChange = (event) => {
        const { name, value } = event.target;
        if (name === "website" || name === "name") {
            handleValidation[name](value);
        }
        dispatch(organizationActions.setOneBasicDetail(name, value));
    };

    return (
        <Fragment>
            <Typography variant="h6" className={classes.description}>
                Basic Details
            </Typography>
            <Typography variant="subtitle2" className={classes.description}>
                This information will be displayed as the Provider for all the AI services your
                company publishes to AI Marketplace
            </Typography>
            <SNETTextfield
                name="id"
                value={id}
                label="Organization id"
                description="The organziation id is the unique id for the organization."
                onChange={handleFormInputsChange}
                disabled
                required
            />
            <SNETTextfield
                name="name"
                value={name}
                label="Organization Name"
                description="The organziation name is displayed to users on the AI Marketplace."
                onChange={handleFormInputsChange}
                maxCount={50}
                error={nameValidation}
                required
            />
            <div className={classes.textareaBox}>
                <SNETTextfield
                    label="Short Description"
                    minRows={4}
                    maxRows={5}
                    fullWidth
                    minCount={shortDescription.length}
                    maxCount={160}
                    inputProps={{ maxLength: 160 }}
                    name="shortDescription"
                    value={shortDescription}
                    onChange={handleFormInputsChange}
                    error={shortDescription.length === 0}
                    required
                    multiline
                />
            </div>
            <div className={classes.textareaBox}>
                <SNETTextfield
                    label="Long Description"
                    minRows={8}
                    maxRows={10}
                    fullWidth
                    minCount={longDescription.length}
                    maxCount={5000}
                    inputProps={{ maxLength: 5000 }}
                    name="longDescription"
                    value={longDescription}
                    onChange={handleFormInputsChange}
                    error={longDescription.length === 0}
                    required
                    multiline
                />
            </div>
            <div className={classes.orgWebsiteUrl}>
                <SNETTextfield
                    name="website"
                    value={website}
                    onChange={handleFormInputsChange}
                    label="Organization Website URL"
                    description="Your organization’s website must be publicly available and the domain name must be associated with your organization."
                    error={websiteValidation}
                    required
                />
            </div>
            <StorageTypeSelecting
                storageProvider={storageProvider}
                setStorageType={handleFormInputsChange}
                setLighthouseToken={handleFormInputsChange}
            />
        </Fragment>
    );
};

export default BasicDetails;
